import * as React from "react";
import Box from "../box";
import type { CenterProps } from "./center.types";
import { getAxisStyles } from "./center.helper";

function Center(props: CenterProps) {
  return (
    <Box {...props} {...getAxisStyles(props.axis)}>
      {props.children}
    </Box>
  );
}

Center.defaultProps = { as: "div", axis: "both" };

export default Center;
